import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

import { ThemeRuntime } from "@/components/runtime/ThemeRuntime";
import { useBusiness } from "./contracts/useBusiness";

const queryClient = new QueryClient();

const App = () => {
  const business = useBusiness();

  useEffect(() => {
    // Title
    document.title = business.seo.title;

    // Meta description
    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", business.seo.description);
  }, [business.seo.title, business.seo.description]);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeRuntime />

        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
